export default {
  props: {
    text: {
      type: String,
      default: 'APP 内打开'
    },
    deviceHeight: {
      type: Number,
      default: 0
    }
  },
  components: {},
  data() {
    return {
      startPageX: 0,
      startPageY: 0,
      X: 0,
      Y: 0,
      availWidth: document.documentElement.clientWidth,
      availHeight: document.documentElement.clientHeight,
      clientWidth: 0,
      clientHeight: 0,
      safeBottomHeight: 0
    };
  },
  computed: {
    position() {
      const maxWidth = this.availWidth - this.clientWidth;
      const maxHeight = this.deviceHeight - this.clientHeight - this.safeBottomHeight;
      const X = this.startPageX + this.X;
      const Y = this.startPageY + this.Y;
      const left = X < 0 ? 0 : X > maxWidth ? maxWidth : X;
      const top = Y < 0 ? 0 : Y > maxHeight ? maxHeight : Y;
      return {
        left,
        top
      };
    },
    styles() {
      const left = this.position.left + 'px';
      const top = this.position.top + 'px';
      return {
        left,
        top
      };
    }
  },
  methods: {
    handleTouchEnd() {
      this.startPageX = this.startPageX + this.X;
      this.startPageY = this.startPageY + this.Y;
      this.X = 0;
      this.Y = 0;
    },
    handleTouchMove(e) {
      this.X = e.X;
      this.Y = e.Y;
    }
  },
  created() {},
  mounted() {
    this.safeBottomHeight = this.$refs.bottom && this.$refs.bottom.offsetHeight;
    this.clientWidth = this.$el.clientWidth;
    this.clientHeight = this.$el.clientHeight;
    this.startPageX = this.availWidth / 2 - this.clientWidth / 2;
    console.log('this.clientHeight', this.clientHeight);
    console.log('this.safeBottomHeight', this.safeBottomHeight);
    this.startPageY = this.deviceHeight - this.clientHeight - 70;
  },
  beforeUnmount() {},
  watch: {}
};